// Spring engine: one rAF loop for everything that bounces (vertical only), shared by the
// Harbor bar and the menu panel. The loop stops as soon as nothing is moving.
const live = new Set();
let raf = 0;
let last = 0;
export const spring = (el, k = .15, d = .8) => el._hbS || (el._hbS = { el, k, d, y: 0, vy: 0, ty: 0 });
export const paint = (s) => { s.el.style.transform = s.y ? `translateY(${s.y.toFixed(2)}px)` : ''; };
function loop(t) {
  const steps = Math.max(1, Math.min(4, Math.round((t - last) / 16.67)));
  last = t;
  live.forEach((s) => {
    for (let i = 0; i < steps; i++) { s.vy = (s.vy + (s.ty - s.y) * s.k) * s.d; s.y += s.vy; }
    if (Math.abs(s.vy) < .01 && Math.abs(s.ty - s.y) < .01) { s.y = s.ty; live.delete(s); }
    paint(s);
  });
  raf = live.size ? requestAnimationFrame(loop) : 0;
}
export function kick(s, reduced) {
  if (reduced) { s.y = s.ty = 0; paint(s); return; }
  live.add(s);
  if (!raf) { last = performance.now(); raf = requestAnimationFrame(loop); }
}

export const rootPx = () => parseFloat(getComputedStyle(document.documentElement).fontSize) || 16;
